export default () => {
  const burgerBth = document.querySelector('.header__wrapper__burger-btn');
  const mobileSidebar = document.querySelector('.mobile-sidebar');
  const body = document.querySelector('body');

  if (burgerBth && mobileSidebar && body) {
    burgerBth.addEventListener('click', (e) => {
      e.preventDefault();
      body.classList.toggle('sidebar-open');
    });
  }
};
